export const METRIC_DEFINITIONS = [
  {
    metricKey: 'dau',
    version: 1,
    name: 'Usuários ativos no dia (DAU)',
    description: 'DAU (Daily Active Users): quantas pessoas diferentes concluíram pelo menos uma ação de uso real no dia, como bater ponto (em qualquer canal: app, web, tablet ou facial), pedir ou aprovar ajuste ou férias, assinar espelho ou documento. Só abrir o sistema não conta (isso é "em uso"). Contam funcionários, gestores, admins e contadores de empresas do universo ativo, uma vez por dia; na visão geral e nas séries por semana ou mês, o número é a média diária do período.',
    formula: 'distintos com pelo menos 1 evento counts_as_active no dia',
    numerator: 'usuários ativos',
    denominator: null,
    window: 'dia',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'wau',
    version: 1,
    name: 'Usuários ativos na semana (WAU)',
    description: 'WAU (Weekly Active Users): quantas pessoas diferentes foram ativas pelo menos uma vez nos 7 dias que terminam no dia de referência (janela móvel, não a semana do calendário), com a mesma regra de ativo e a mesma base do DAU. Na visão geral, o dia de referência é o último dia com dados do período: é a foto desse dia, não uma média.',
    formula: 'distintos ativos nos 7 dias terminando no dia',
    numerator: 'usuários ativos',
    denominator: null,
    window: 'janela móvel de 7 dias',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'mau',
    version: 1,
    name: 'Usuários ativos no mês (MAU)',
    description: 'MAU (Monthly Active Users): quantas pessoas diferentes foram ativas pelo menos uma vez nos 30 dias que terminam no dia de referência (janela móvel, não o mês do calendário; na visão geral, o último dia com dados do período). Ativo é quem concluiu ação de uso real (bater ponto, ajuste, aprovação, férias, espelho, documento...); só abrir o sistema não conta. Contam funcionários, gestores, admins e contadores de empresas do universo ativo.',
    formula: 'distintos ativos nos 30 dias terminando no dia',
    numerator: 'usuários ativos',
    denominator: null,
    window: 'janela móvel de 30 dias',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'stickiness',
    version: 1,
    name: 'Stickiness (DAU/MAU)',
    description: 'Stickiness: mede o hábito, isto é, que parte de quem foi ativo nos últimos 30 dias usa num dia qualquer (DAU ÷ MAU); 60% quer dizer que, em média, 6 de cada 10 desses ativos usaram em cada dia. Na visão geral é a média do DAU do período ÷ a média do MAU; no engajamento vale cada ponto da série, e o WAU/MAU ao lado faz a mesma conta com a janela de 7 dias.',
    formula: 'DAU dividido por MAU',
    numerator: 'DAU',
    denominator: 'MAU',
    window: 'dia',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'in_use',
    version: 1,
    name: 'Usuários em uso',
    description: 'Em uso: quem abriu o sistema (web, app ou backoffice) ou registrou qualquer evento, mesmo sem ação de uso real, como ler um comunicado ou consultar o People Analytics; todo ativo também está em uso, com a mesma base de perfis e empresas. A janela segue o rótulo (dia, 7 ou 30 dias; nas tabelas, 30 dias), e a diferença para os ativos ("abriram sem agir") é quem apareceu sem concluir nenhuma ação de uso real.',
    formula: 'distintos com session.opened ou evento counts_as_in_use no período',
    numerator: 'usuários em uso',
    denominator: null,
    window: 'dia, semana ou mês',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: '2026-10-24',
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'in_use',
    version: 2,
    name: 'Usuários em uso',
    description: 'Em uso: quem abriu o sistema (web, app ou backoffice) ou registrou qualquer evento, mesmo sem ação de uso real, como ler um comunicado ou consultar o People Analytics; todo ativo também está em uso, com a mesma base de perfis e empresas. O login automático do tablet MarQTab (a cada 15 min, mesmo sem ninguém usar) não conta como abertura; batida e demais ações no tablet continuam contando. A série toda segue esta regra: o histórico desde 31/08/2026, primeiro dia com esse login nos dados, foi recomposto. A abertura da V2 no navegador (sessão da V2) também conta, a partir do dia em que a chave sink:V2:session foi ligada. A janela segue o rótulo (dia, 7 ou 30 dias; nas tabelas, 30 dias), e a diferença para os ativos ("abriram sem agir") é quem apareceu sem concluir nenhuma ação de uso real.',
    formula: 'distintos com session.opened ou evento counts_as_in_use no período, exceto session.opened do tablet (plataforma 4)',
    numerator: 'usuários em uso',
    denominator: null,
    window: 'dia, semana ou mês',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-24',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Login automático do tablet MarQTab fora do em uso (CJ-1, doc 12); histórico recomposto desde 31/08/2026; sessão da V2 no navegador conta como abertura quando ligada (CJ-3, D-04)',
  },
  {
    metricKey: 'was',
    version: 1,
    name: 'Weekly Active Seats (WAS)',
    description: 'WAS (Weekly Active Seats): que parte dos usuários habilitados esteve em uso nos 7 dias que terminam no dia de referência, isto é, abriu o sistema ou fez alguma ação. Habilitado é o usuário ativo e não excluído, com perfil funcionário, gestor, admin ou contador, em empresa do universo. Mostra quanto da base cadastrada aparece no sistema.',
    formula: 'habilitados em uso na semana / habilitados x 100',
    numerator: 'habilitados em uso nos 7 dias',
    denominator: 'habilitados elegíveis no snapshot do último dia',
    window: 'janela móvel de 7 dias',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: '2026-10-24',
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'was',
    version: 2,
    name: 'Weekly Active Seats (WAS)',
    description: 'WAS (Weekly Active Seats): que parte dos usuários habilitados esteve em uso nos 7 dias que terminam no dia de referência, isto é, abriu o sistema ou fez alguma ação; o login automático do tablet MarQTab, a cada 15 min, não conta como abertura (a série toda segue esta regra, com o histórico recomposto desde 31/08/2026); a abertura da V2 no navegador (sessão da V2) também conta, a partir do dia em que a chave sink:V2:session foi ligada. Habilitado é o usuário ativo e não excluído, com perfil funcionário, gestor, admin ou contador, em empresa do universo. Mostra quanto da base cadastrada aparece no sistema.',
    formula: 'habilitados em uso na semana / habilitados x 100',
    numerator: 'habilitados em uso nos 7 dias',
    denominator: 'habilitados elegíveis no snapshot do último dia',
    window: 'janela móvel de 7 dias',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-24',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Em uso v2: login automático do tablet MarQTab fora do numerador (CJ-1, doc 12); histórico recomposto desde 31/08/2026; sessão da V2 no navegador conta como abertura quando ligada (CJ-3, D-04)',
  },
  {
    metricKey: 'active_companies',
    version: 1,
    name: 'Empresas com uso real',
    description: 'Empresas com uso real: quantas empresas do universo (ativas, não deletadas, fora do HideFromReports e do tenant Portugal) tiveram pelo menos uma pessoa com ação de uso real, como bater ponto ou aprovar ajuste, nos 30 dias que terminam no dia de referência. Empresa ativa no cadastro em que ninguém agiu não entra, mesmo que alguém tenha só aberto o sistema.',
    formula: 'empresas do universo ativo, não internas, com pelo menos 1 usuário ativo',
    numerator: 'empresas com uso',
    denominator: null,
    window: 'período',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'active_seats_rate',
    version: 1,
    name: 'Active Seats Rate',
    description: 'Active Seats Rate: que parte dos usuários habilitados foi ativa, isto é, concluiu ação de uso real (não só abriu o sistema), nos 30 dias que terminam no dia de referência (ativos habilitados ÷ habilitados × 100). Habilitado é o usuário ativo e não excluído, com perfil funcionário, gestor, admin ou contador, em empresa do universo, contado no dia de referência. Nunca passa de 100%.',
    formula: 'ativos distintos / habilitados elegíveis x 100',
    numerator: 'usuários ativos',
    denominator: 'habilitados elegíveis (Funcionário, Gestor, Admin, Contador)',
    window: 'período',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'contract_utilization',
    version: 1,
    name: 'Utilização do contrato',
    description: 'Utilização do contrato: compara quem usou com o que foi contratado, isto é, ativos habilitados nos 30 dias ÷ assentos da assinatura ativa (MaxTotalEmployeeInContract) × 100. No total, entram só as empresas com assinatura ativa. Pode passar de 100% (mais ativos que assentos) e fica n/d sem assinatura ativa ou com filtro de plataforma ou módulo.',
    formula: 'ativos distintos / assentos contratados x 100',
    numerator: 'usuários ativos',
    denominator: 'MaxTotalEmployeeInContract da assinatura ativa',
    window: 'período',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'feature_adoption',
    version: 1,
    name: 'Adoção de feature',
    description: 'Adoção: que parte de quem pode usar a funcionalidade de fato usou nos 30 dias, isto é, usuários com pelo menos um uso registrado nela ÷ elegíveis (habilitados, com perfil que usa a funcionalidade, em empresas do universo que a têm ligada). Conta qualquer evento medido da funcionalidade, inclusive consulta quando é o único sinal (como abrir o People Analytics). Sem evento medido aparece "sem medição" (não zero); com menos de 30 elegíveis, "dados insuficientes".',
    formula: 'usuários distintos com evento da feature / usuários elegíveis x 100',
    numerator: 'usuários adotantes',
    denominator: 'habilitados de empresas com a feature e perfil aplicável',
    window: 'período',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'feature_company_adoption',
    version: 1,
    name: 'Adoção de feature por empresa',
    description: 'Adoção por empresa: das empresas do universo com a funcionalidade habilitada, quantas tiveram pelo menos um usuário elegível usando-a nos 30 dias. Funcionalidade com chave conta só as empresas com a chave ligada no cadastro; a liberada para todos conta todas as empresas do universo. Mostra funcionalidade ligada e não usada.',
    formula: 'empresas com uso / empresas habilitadas x 100',
    numerator: 'empresas adotantes',
    denominator: 'empresas com a feature ativa',
    window: 'período',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'feature_recurrence',
    version: 1,
    name: 'Recorrência de feature',
    description: 'Recorrência: que parte dos adotantes usou a funcionalidade em pelo menos 2 semanas diferentes (segunda a domingo) nos 30 dias. Separa uso pontual de uso repetido; em funcionalidade de ciclo mensal (fechamento, assinatura do espelho, férias, reembolso), recorrência baixa é o esperado.',
    formula: 'adotantes com uso em pelo menos 2 semanas ISO distintas / adotantes',
    numerator: 'adotantes recorrentes',
    denominator: 'adotantes',
    window: '30 dias',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'feature_frequency',
    version: 1,
    name: 'Frequência de feature',
    description: 'Frequência: quantas ações bem-sucedidas, em média, cada adotante fez na funcionalidade por semana, isto é, o total dos 30 dias ÷ adotantes ÷ 4,3 semanas. Só contam ações de quem é elegível; falhas ficam fora. Se a medição da funcionalidade começou há menos de 30 dias (estado parcial), o valor sai subestimado.',
    formula: 'ações da feature por adotante por semana',
    numerator: 'ações',
    denominator: 'adotantes x semanas',
    window: 'período',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'feature_intensity',
    version: 1,
    name: 'Intensidade de feature',
    description: 'Intensidade: mediana de dias diferentes, nos 30 dias, em que cada adotante usou a funcionalidade (metade usou em menos dias, metade em mais). Ainda não é calculada: aparece como n/d em todas as funcionalidades, porque os dias com uso por adotante não são pré-agregados.',
    formula: 'mediana de dias com uso por adotante no mês',
    numerator: null,
    denominator: null,
    window: '30 dias',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'feature_depth',
    version: 1,
    name: 'Profundidade de feature',
    description: 'Profundidade: das ações da funcionalidade que medimos (as do catálogo), quantas foram usadas por alguém, em toda a base, nos 30 dias. Basta uma empresa usar uma ação para ela contar, e a maioria das funcionalidades tem uma só ação medida (aí o valor é 0% ou 100%); diz mais nas que têm várias, como controle de ponto, férias e reembolso.',
    formula: 'ações distintas usadas / ações catalogadas da feature',
    numerator: 'ações usadas',
    denominator: 'ações do catálogo',
    window: 'período',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'activation_rate_30d',
    version: 1,
    name: 'Activation Rate (30 dias)',
    description: 'Activation Rate: que parte das empresas criadas no período (na tabela, por mês; na visão geral, o período recuado 30 dias) chegou à primeira batida de ponto de um colaborador em até 30 dias da criação, o marco de empresa ativada. Conta toda empresa criada, inclusive trial e as depois desativadas, menos as criadas antes do início da medição das batidas (censuradas); empresa ainda dentro dos 30 dias só entra quando a janela fecha (até lá, Parcial ou Pendente).',
    formula: 'empresas com 1ª batida de colaborador em até 30 dias da criação / empresas da coorte',
    numerator: 'empresas ativadas',
    denominator: 'empresas criadas no mês, não internas',
    window: 'coorte mensal',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: '2026-10-26',
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'activation_rate_30d',
    version: 2,
    name: 'Activation Rate (30 dias)',
    description: 'Activation Rate: que parte das empresas vendidas chegou à primeira batida de ponto de um colaborador até D+30, contando do D0 = data da 1ª venda (registro de venda; sem ele, venda inicial do catálogo, 1º pagamento ou, para a paga sem outra evidência, a criação). Só entram as empresas com a janela de 30 dias fechada e gravada; as em andamento, as aguardando medição, as expurgadas e as de shard sem o índice de batidas ficam fora do denominador e aparecem em nota. Batida excluída não conta. Na visão geral, a coorte é a das vendas 30 dias antes do período. Quebra de série: a v1 contava da criação e todas as empresas.',
    formula: 'empresas vendidas com 1ª batida de colaborador (Role 1, não excluída) até D0 + 30 / empresas vendidas com a janela de 30 dias fechada e a batida medida (D0 = 1ª venda, dia de Brasília; expurgadas fora)',
    numerator: 'empresas vendidas com 1ª batida até D+30',
    denominator: 'empresas vendidas com a janela D+30 fechada, gravada e medida, menos expurgadas',
    window: 'D0 até D0 + 30 (coorte pela data da venda)',
    timezoneRule: 'Dia de Brasília (UTC-03:00 fixo)',
    validFrom: '2026-10-26',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'D0 = data da 1ª venda e universo = vendidas, com a 1ª batida lida do shard por janela D+30 (doc 13, ativação por janela D15/D30/D60)',
  },
  {
    metricKey: 'time_to_activation',
    version: 1,
    name: 'Tempo até ativação',
    description: 'Tempo até ativação: quantos dias passam entre a criação da empresa e a primeira batida de ponto de um colaborador, contando só as empresas do período que ativaram em até 30 dias (as que não ativaram ou demoraram mais ficam fora). A mediana é o prazo em que metade dessas empresas ativou; o p75, o prazo em que 3 de cada 4 delas ativaram.',
    formula: 'dias entre a criação e a 1ª batida (mediana e p75)',
    numerator: null,
    denominator: null,
    window: 'coorte mensal',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: '2026-10-26',
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'time_to_activation',
    version: 2,
    name: 'Tempo até ativação',
    description: 'Tempo até ativação: quantos dias passam entre o D0 (data da 1ª venda) e a primeira batida de ponto de um colaborador, entre as empresas vendidas que bateram até D+30 (as que não bateram até lá ficam fora). Batida antes da venda, ainda no trial, conta como D+0. A mediana é o prazo em que metade dessas empresas bateu; o p75, o prazo em que 3 de cada 4 bateram. Quebra de série: a v1 contava da criação e todas as empresas.',
    formula: 'dias entre o D0 (1ª venda) e a 1ª batida de colaborador (Role 1, não excluída), entre as vendidas que bateram até D0 + 30 (mediana e p75; batida antes da venda = 0)',
    numerator: null,
    denominator: null,
    window: 'D0 até D0 + 30 (coorte pela data da venda)',
    timezoneRule: 'Dia de Brasília (UTC-03:00 fixo)',
    validFrom: '2026-10-26',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Mesmo recorte do Activation Rate 30d v2: D0 = data da 1ª venda, vendidas que bateram até D+30 (doc 13, ativação por janela D15/D30/D60)',
  },
  {
    metricKey: 'user_activation_7d',
    version: 1,
    name: 'Ativação de usuário',
    description: 'Ativação de usuário: dos usuários de qualquer perfil cadastrados no período na empresa escolhida, que parte fez a primeira ação de uso real (bater ponto, pedir ajuste etc.) em até 7 dias do cadastro. Só é calculada com uma empresa no filtro (sem ela, n/d); quem foi cadastrado há menos de 7 dias ainda não entra, e quem foi cadastrado antes do início da medição fica de fora.',
    formula: 'usuários com 1ª ação significativa em até 7 dias da criação / usuários criados',
    numerator: 'usuários ativados',
    denominator: 'usuários criados na semana',
    window: 'coorte semanal',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'retention_user',
    version: 1,
    name: 'Retenção de usuários',
    description: 'Retenção de usuários: acompanha um grupo (coorte) de pessoas que fizeram a primeira ação de uso real no mesmo dia, semana ou mês e mostra que parte delas voltou a ser ativa N períodos depois (W4 = 4 semanas). O valor é acumulado (voltou em algum momento até ali), o exato do período aparece ao passar o mouse, e a célula só aparece quando o período já terminou; no card Retenção W4, é a média das coortes semanais cuja 4ª semana terminou no período, ponderada pelo tamanho.',
    formula: 'retidos acumulados até o offset / tamanho da coorte (coorte = semana ou mês da 1ª ação)',
    numerator: 'retidos',
    denominator: 'tamanho da coorte',
    window: 'D, W ou M',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'retention_company',
    version: 1,
    name: 'Retenção de empresas',
    description: 'Retenção de empresas: pega as empresas ativadas no mesmo mês (primeira batida de colaborador em até 30 dias da criação) e mostra que parte delas voltou a ter uso ativo, isto é, alguém da empresa concluiu uma ação de uso real, em algum momento até N meses depois (valor acumulado; o exato do mês aparece ao passar o mouse). A célula só aparece quando o mês já terminou.',
    formula: 'empresas ativas no offset / empresas ativadas no mês',
    numerator: 'retidas',
    denominator: 'empresas da coorte',
    window: 'M',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'success_rate',
    version: 1,
    name: 'Taxa de sucesso funcional',
    description: 'Taxa de sucesso: das tentativas distintas de uma operação (repetir a mesma tentativa conta uma vez), quantas terminaram bem; recusa da regra e erro técnico contam como falha e aparecem separados no detalhe. Só existe para operação em que a falha é registrada (gerar espelho, reconhecimento facial na batida, execução, salvamento e exportação do relatório avançado); nas demais, e na batida, aparece só o volume concluído, e com menos de 30 tentativas sai como dados insuficientes.',
    formula: 'sucessos / tentativas distintas por dedupe_key x 100',
    numerator: 'sucessos',
    denominator: 'tentativas elegíveis',
    window: 'período',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'top10_concentration',
    version: 1,
    name: 'Concentração top 10',
    description: 'Concentração top 10: quanto do MAU vem das 10 empresas com mais pessoas ativas nos 30 dias (MAU dessas 10 ÷ MAU total). Valor alto indica dependência de poucos clientes grandes.',
    formula: 'MAU das 10 maiores empresas / MAU total',
    numerator: 'MAU top 10',
    denominator: 'MAU total',
    window: '30 dias',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-16',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (plano 02 §8)',
  },
  {
    metricKey: 'onboarding_started',
    version: 1,
    name: 'Iniciaram o uso (D+15, D+30, D+60)',
    description: 'Iniciaram o uso: que parte das empresas vendidas cadastrou pelo menos um colaborador até D+15, D+30 ou D+60, contando do D0 = data da 1ª venda; colaborador desligado depois continua contando e o dono da conta não conta. Só entram as janelas já fechadas e gravadas: as em andamento, as aguardando medição e as expurgadas (excluídas sem nenhum registro) ficam fora do denominador e aparecem em nota. Empresas de teste do Master nunca entram.',
    formula: 'empresas vendidas com 1º colaborador (Role 1) cadastrado até D0 + N / empresas vendidas com a janela N fechada e gravada, menos expurgadas',
    numerator: 'empresas com colaborador cadastrado até D+N',
    denominator: 'empresas vendidas com a janela D+N fechada e gravada, menos expurgadas',
    window: 'D0 até D0 + N, N = 15, 30 ou 60 (coorte pela data da venda)',
    timezoneRule: 'Dia de Brasília (UTC-03:00 fixo)',
    validFrom: '2026-10-26',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (doc 13, ativação por janela D15/D30/D60)',
  },
  {
    metricKey: 'onboarding_milestone_rate',
    version: 1,
    name: 'Marco de ativação até D+N',
    description: 'Marco até D+N: que parte das empresas atingiu cada item do checklist de ativação (colaborador; gestor ou admin além do dono; turno ou escala configurado; equipe própria; cerco próprio; MarQTab ou REP; 1ª batida; 1º espelho ou fechamento) até D+15, D+30 ou D+60 do D0 (data da venda). O que nasce com a empresa (turno, equipe e cerco criados no 1º minuto) não conta, mesmo renomeado; as regras de ponto da empresa não são medidas. Marco de shard sem o índice fica "não medido" e sai do denominador só daquele marco.',
    formula: 'empresas que atingiram o marco até D0 + N / empresas com a janela N fechada, gravada e o marco medido (turno, equipe e cerco criados nos 60 s da criação não contam)',
    numerator: 'empresas que atingiram o marco até D+N',
    denominator: 'empresas com a janela D+N fechada, gravada e o marco medido, menos expurgadas',
    window: 'D0 até D0 + N, N = 15, 30 ou 60 (coorte pela data da venda)',
    timezoneRule: 'Dia de Brasília (UTC-03:00 fixo)',
    validFrom: '2026-10-26',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (doc 13, ativação por janela D15/D30/D60)',
  },
  {
    metricKey: 'first_value_rate',
    version: 1,
    name: 'Primeiro valor (ponto em operação)',
    description: 'Primeiro valor (ponto em operação): que parte das empresas vendidas teve, até D+N, um dia em que, nos 7 dias que terminam nele, houve batida em pelo menos 3 dias diferentes e bateram pelo menos 50% dos colaboradores cadastrados até aquele dia (mínimo 1). Só contam batidas não excluídas de colaboradores; a 1ª batida sozinha costuma ser teste, por isso o valor é a equipe batendo ponto.',
    formula: 'empresas com um dia D <= D0 + N em que, de D-6 a D, houve batida em >= 3 dias e bateram >= CEILING(0,5 x colaboradores cadastrados até D), mínimo 1 / empresas com a janela N fechada, gravada e a batida medida',
    numerator: 'empresas em operação até D+N',
    denominator: 'empresas com a janela D+N fechada, gravada e a batida medida, menos expurgadas',
    window: 'D0 até D0 + N, N = 15, 30 ou 60 (coorte pela data da venda)',
    timezoneRule: 'Dia de Brasília (UTC-03:00 fixo)',
    validFrom: '2026-10-26',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (doc 13, ativação por janela D15/D30/D60)',
  },
  {
    metricKey: 'time_to_first_value',
    version: 1,
    name: 'Tempo até o primeiro valor',
    description: 'Tempo até o primeiro valor: quantos dias passam entre o D0 (data da 1ª venda) e o primeiro dia em que a empresa entrou em operação (batida em pelo menos 3 dias da semana e de pelo menos 50% dos colaboradores), entre as vendidas com D+60 fechado que chegaram lá até D+60. Mostra mediana e p75; o histograma mostra também as que não chegaram. Valor antes da venda conta como D+0.',
    formula: 'dias entre o D0 (1ª venda) e o 1º dia em operação, entre as vendidas com D+60 fechado que entraram em operação até D0 + 60 (mediana, p75 e faixas 0-3, 4-7, 8-14, 15-30, 31-60 e não atingiu)',
    numerator: null,
    denominator: null,
    window: 'D0 até D0 + 60 (coorte pela data da venda)',
    timezoneRule: 'Dia de Brasília (UTC-03:00 fixo)',
    validFrom: '2026-10-26',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (doc 13, ativação por janela D15/D30/D60)',
  },
  {
    metricKey: 'habit_rate',
    version: 1,
    name: 'Rotina na semana do D+N',
    description: 'Rotina: que parte das empresas vendidas, na semana que termina em D+N (de D+N-6 a D+N), teve batida em pelo menos 4 dias diferentes e de pelo menos 50% dos colaboradores cadastrados até D+N (mínimo 1). Mede se o ponto virou hábito ao fim de cada janela, não só se a empresa começou a usar.',
    formula: 'empresas que, de D0 + N - 6 a D0 + N, tiveram batida em >= 4 dias e de >= CEILING(0,5 x colaboradores cadastrados até D0 + N), mínimo 1 / empresas com a janela N fechada, gravada e a batida medida',
    numerator: 'empresas em rotina na semana do D+N',
    denominator: 'empresas com a janela D+N fechada, gravada e a batida medida, menos expurgadas',
    window: 'D0 até D0 + N, N = 15, 30 ou 60 (coorte pela data da venda)',
    timezoneRule: 'Dia de Brasília (UTC-03:00 fixo)',
    validFrom: '2026-10-26',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (doc 13, ativação por janela D15/D30/D60)',
  },
  {
    metricKey: 'onboarding_stage',
    version: 1,
    name: 'Etapa da ativação em D+N',
    description: 'Etapa da ativação em D+N: a mais avançada atingida até D+N, na ordem 0 sem colaborador, 1 cadastrou colaboradores, 2 configurou turno ou escala, 3 bateu ponto, 4 em operação (primeiro valor), 5 rotina; a etapa mais avançada implica as anteriores (quem bateu sem configurar turno aparece como "pulou a configuração"). Os gargalos são as duas piores conversões entre etapas seguidas, com base de pelo menos 20 empresas.',
    formula: 'distribuição das empresas com a janela N fechada pela maior etapa atingida até D0 + N (0 sem colaborador, 1 colaboradores, 2 turno ou escala, 3 bateu ponto, 4 em operação, 5 rotina); conversão = empresas na etapa >= k + 1 / empresas na etapa >= k, gargalo com base >= 20',
    numerator: 'empresas na etapa',
    denominator: 'empresas com a janela D+N fechada, gravada e a batida medida, menos expurgadas',
    window: 'D0 até D0 + N, N = 15, 30 ou 60 (coorte pela data da venda)',
    timezoneRule: 'Dia de Brasília (UTC-03:00 fixo)',
    validFrom: '2026-10-26',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (doc 13, ativação por janela D15/D30/D60)',
  },
  {
    metricKey: 'report_visit_funnel',
    version: 1,
    name: 'Funil da visita do relatório avançado',
    description: 'Funil da visita ao relatório avançado. Visita = eventos do mesmo usuário na tela com menos de 30 minutos entre um e outro. Etapas: abriu (toda visita), executou (pelo menos uma execução com resposta), mudou a configuração (2 ou mais configurações diferentes tentadas na visita; trocar só o valor de um filtro não conta), teve resultado (exportou ou salvou) e voltou (executou de novo em outro dia, em até 7 dias). Mudou, resultado e voltou são frações das visitas que executaram; voltou só vale para visitas com os 7 dias seguintes já fechados. O período começa no dia em que os eventos foram ligados.',
    formula: 'visitas da etapa / visitas da etapa-base; visita = eventos do usuário em pa.report_usage_event com intervalo < 30 min; executou = ran page=1 com result=1; mudou = executou e COUNT(DISTINCT cfg das tentativas page=1) >= 2; resultado = exported ou saved com result=1; voltou = executou e há visita do mesmo usuário com ran ok em local_date de d+1 a d+7',
    numerator: 'visitas que chegaram à etapa',
    denominator: 'visitas que abriram (executou) ou que executaram (mudou, resultado, voltou com 7 dias fechados)',
    window: 'período escolhido, a partir do dia em que os eventos foram ligados (visita pelo dia local do 1º evento)',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-27',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (doc 14, telemetria do relatório avançado)',
  },
  {
    metricKey: 'report_user_segment',
    version: 1,
    name: 'Segmento de uso do relatório avançado',
    description: 'Segmento de quem entrou no relatório avançado nos 30 dias que terminam no fim do período, avaliado nesta ordem: Só abriu (nenhuma execução), Tira valor (exportou ou salvou 3 configurações diferentes ou mais, ou viu dados na tela em 3 dias diferentes ou mais), Uso pontual (exportou ou salvou ao menos uma vez), Travou (metade ou mais das execuções recusada ou vazia, ou só erro do servidor), Explorou sem resultado (5 ou mais configurações tentadas) e Consultou na tela (o resto). Resultado é exportar ou salvar; ver dados na tela é execução com linhas ou modelo do sistema que voltou vazio (o vazio é a resposta dele). Erro do servidor fica fora da conta do Travou. Os limiares são da versão 1 e serão revistos com 30 dias de dados.',
    formula: 'por usuário, janela [to-29, to]: tentativas (ran page=1), boas (ok e não vazias, ou vazias com tpl), ruins (recusadas, ou ok vazias sem tpl), técnicas (result=3), dias com execução boa, configurações tentadas e com resultado (cfg distintos), resultados; CASE em ordem: tentativas = 0 e resultados = 0 -> so_abriu; cfgs com resultado >= 3 ou dias bons >= 3 -> tira_valor; resultados >= 1 -> uso_pontual; tentativas = técnicas ou ruins x 100 >= 50 x (tentativas - técnicas) -> travou; cfgs tentados >= 5 -> explorou; senão consultou',
    numerator: 'usuários no segmento',
    denominator: 'usuários com visita ao relatório avançado na janela',
    window: '30 dias terminando no fim do período',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-27',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (doc 14, telemetria do relatório avançado)',
  },
  {
    metricKey: 'report_combination_value',
    version: 1,
    name: 'Combinação do relatório avançado que dá resultado',
    description: 'Para cada combinação de relatório (cadastro, jornada, batidas...), modo (lista ou agrupado) e campos de agrupamento, quantas visitas que a executaram terminaram em exportação ou relatório salvo dessa mesma combinação, e quantos usuários voltaram a executá-la em outro dia. Só entram combinações executadas por 3 usuários ou mais; as outras somam numa linha só. Trocar colunas, filtros ou período não muda a combinação.',
    formula: 'combinação = record x mode x group_by; taxa de resultado = visitas com exported/saved ok da combinação / visitas com ran ok da combinação; retorno = usuários com ran bom (ok e não vazio, ou vazio com tpl) da combinação em >= 2 dias / usuários com ran ok da combinação; só combinações com >= 3 usuários',
    numerator: 'visitas com resultado da combinação; usuários que voltaram',
    denominator: 'visitas e usuários que executaram a combinação',
    window: 'período escolhido, a partir do dia em que os eventos foram ligados',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-27',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (doc 14, telemetria do relatório avançado)',
  },
  {
    metricKey: 'report_run_problems',
    version: 1,
    name: 'Onde o relatório avançado trava',
    description: 'Recusas e erros do relatório avançado por código (período não informado, coluna de módulo não contratado, campo personalizado em grupo OU...) e por relatório, com quantas visitas terminaram nesse erro sem uma execução bem-sucedida depois; e execuções que voltaram vazias por relatório e modo. Bloqueios que a própria tela faz antes de chamar o servidor (botão desabilitado, filtro incompleto) não aparecem.',
    formula: 'falhas = eventos ran, exported, saved, deleted ou favorited com result 2 (código REPORT.*) ou 3 (tipo da exceção), por código e record; terminou no erro = visitas cuja última tentativa page=1 falhou; vazias = ran page=1 ok com empty=true / ran page=1 ok, por record e mode',
    numerator: 'falhas, visitas que terminaram no erro, execuções vazias',
    denominator: 'execuções page=1 com resposta (para a taxa de vazias)',
    window: 'período escolhido, a partir do dia em que os eventos foram ligados',
    timezoneRule: 'Dia local da empresa (Company.DefaultTimeZone; padrão E. South America Standard Time)',
    validFrom: '2026-10-27',
    validTo: null,
    changedBy: 'product-analytics',
    changeReason: 'Definição inicial (doc 14, telemetria do relatório avançado)',
  },
];

export const KPI_DEFINITION_KEYS = {
  dau: 'dau',
  wau: 'wau',
  mau: 'mau',
  stickiness: 'stickiness',
  inUse: 'in_use',
  was: 'was',
  activeCompanies: 'active_companies',
  activeSeatsRate: 'active_seats_rate',
  contractUtilization: 'contract_utilization',
  adoption: 'feature_adoption',
  companyAdoption: 'feature_company_adoption',
  recurrence: 'feature_recurrence',
  frequency: 'feature_frequency',
  intensity: 'feature_intensity',
  depth: 'feature_depth',
  activation30d: 'activation_rate_30d',
  activationRate: 'activation_rate_30d',
  medianDays: 'time_to_activation',
  p75Days: 'time_to_activation',
  timeToActivation: 'time_to_activation',
  userActivation7d: 'user_activation_7d',
  retentionW4: 'retention_user',
  retentionUser: 'retention_user',
  retentionCompany: 'retention_company',
  successRate: 'success_rate',
  top10Concentration: 'top10_concentration',
  top10Share: 'top10_concentration',
};

const byKey = {};
METRIC_DEFINITIONS.forEach((definition) => {
  const current = byKey[definition.metricKey];
  if (!current || (definition.version || 0) > (current.version || 0)) byKey[definition.metricKey] = definition;
});

export const metricKeyFor = (key) => {
  if (!key) return null;
  if (byKey[key]) return key;
  return Object.prototype.hasOwnProperty.call(KPI_DEFINITION_KEYS, key) ? KPI_DEFINITION_KEYS[key] : null;
};

export const definitionFor = (key, overrides) => {
  const metricKey = metricKeyFor(key);
  if (!metricKey) return null;
  const local = byKey[metricKey] || null;
  const remote = (overrides || []).filter((row) => row && row.metricKey === metricKey)
    .sort((a, b) => (b.version || 0) - (a.version || 0))[0];
  if (!local && !remote) return null;
  const merged = Object.assign({}, local || {}, remote || {});
  if (!merged.description && local && local.description) merged.description = local.description;
  return merged;
};

export const definitionDescription = (definition) =>
  definition && typeof definition.description === 'string' ? definition.description : '';

export const definitionLines = (definition) => {
  if (!definition) return [];
  const lines = [
    { label: 'Fórmula', text: definition.formula },
    { label: 'Numerador', text: definition.numerator },
    { label: 'Denominador', text: definition.denominator },
    { label: 'Janela', text: definition.window },
    { label: 'Fuso', text: definition.timezoneRule },
  ];
  return lines.filter((line) => typeof line.text === 'string' && line.text);
};

export const definitionVersionText = (definition, envelopeVersion) => {
  const version = definition && definition.version ? definition.version : envelopeVersion;
  if (!version) return '';
  const since = definition && definition.validFrom ? ' desde ' + definition.validFrom.split('-').reverse().join('/') : '';
  return 'Versão ' + version + since;
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piDefinitions.js